import { useState, useCallback } from 'react';
import { message } from 'antd';
import { pw0308Api, PW0308ReportRow, PW0308ReportParams } from '../../../services/pw0308Api';

/**
 * BR-V01: auto-compute endUser from startUser.
 * TRIM(startUser) + 'zzzzzzzz...' truncated to 8 chars.
 * e.g. "A001" => "A001zzzz"
 */
function autoComputeEndUser(start: string): string {
  const trimmed = start.trim();
  if (!trimmed) return '';
  return (trimmed + 'zzzzzzzz').slice(0, 8);
}

export function usePW0308Report() {
  const [loading, setLoading] = useState(false);
  const [records, setRecords] = useState<PW0308ReportRow[]>([]);
  const [total, setTotal] = useState(0);

  const [startUser, setStartUser]   = useState('');
  const [endUser, setEndUser]       = useState('');
  const [startDate, setStartDate]   = useState('');
  const [endDate, setEndDate]       = useState('');

  // BR-V01: when startUser is confirmed (blur/select), auto-fill endUser
  const handleStartUserConfirm = useCallback((code: string) => {
    const computed = autoComputeEndUser(code);
    if (computed) {
      setEndUser(computed);
    }
  }, []);

  const handleQuery = useCallback(async () => {
    setLoading(true);
    try {
      const params: PW0308ReportParams = {
        startUser:  startUser  || undefined,
        endUser:    endUser    || undefined,
        startDate:  startDate  || undefined,
        endDate:    endDate    || undefined,
      };
      const res = await pw0308Api.getReport(params);
      setRecords(res.items || []);
      setTotal(res.total || 0);
    } catch (err: unknown) {
      const errorMessage = err instanceof Error ? err.message : '查詢失敗';
      message.error(errorMessage);
      setRecords([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  }, [startUser, endUser, startDate, endDate]);

  return {
    loading,
    records,
    total,
    startUser, setStartUser,
    endUser, setEndUser,
    startDate, setStartDate,
    endDate, setEndDate,
    handleQuery,
    handleStartUserConfirm,
  };
}
